import Vue from 'vue'
import App from './App'

import format from 'string-format'

format.extend(String.prototype, {})

import moment from 'moment'

Vue.prototype.$moment = moment;//赋值使用
moment.locale('zh-cn');//需要汉化

/*饿了么组件*/
import ElementUI from 'element-ui'

Vue.use(ElementUI)

/*引入管理后台主题样式*/
import './assets/theme/theme-green/index.css'

import './assets/theme/theme-green/alert.css';
import './assets/theme/theme-green/message.css';//原样式有BUG，已作调整
import './assets/theme/theme-green/message-box.css';//原样式有BUG，已作调整
import './assets/theme/theme-green/dialog.css';
import './assets/theme/theme-green/calendar.css';

import 'font-awesome/css/font-awesome.min.css'

/*进度条NProgress组件*/
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(NProgress)
NProgress.configure({showSpinner: false});

/*Mock组件*/
import Mock from './mock'

Mock.bootstrap();

/*路由及状态管理*/
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import router from './router/index'

Vue.use(VueRouter)
Vue.use(Vuex)

/*vuetify全局引入*/
import Vuetify from 'vuetify'
import './assets/vuetify.css';
import colors from 'vuetify/es5/util/colors'/*色彩包*/
Vue.use(Vuetify, {
    theme: {
        primary: colors.red.darken1, // #E53935
        secondary: colors.red.lighten4, // #FFCDD2
        accent: colors.indigo.base // #3F51B5
    }
})

import scroll from 'vue-seamless-scroll'

Vue.use(scroll, {componentName: 'scroll-seamless'})

new Vue({
    el: '#app',
    template: '<App/>',
    router,
    store,
    components: {App},
    render: h => h(App, {})
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js